import React from "react";
import contextProvider from "app/contextProvider";

import _ReactOBaseComponent, {
  withDefinedContext,
} from "app/_L0_components/_ReactOBaseComponent";

import deepEqual from "deep-equal";
import { Form } from "reactstrap";

import ReactOModal from "app/_L1_components/Elements/ReactOModal";

const context_exposed_methods = [
  "isReady",
  "handleFormChange",
  "getEntry",
  "setEntry",
  "getFormData",
  "_cleanHiddenEntries",
  "setFormData",
  "validate",
  "isValid",
  "isInvalid",
  "isChanged",
  "getValidationResult",
  "isDirty",
  "resetDefault",
  "evaluateDefinition",
  "defineEntry",
  "destroyEntry",
  "restoreData",
  "submitOnEnterKey",
  "submit",
  "init",
  "getErrorMessage",
  "registerInput",
  "unregisterInput",
  "getRegisteredInputs",
  "isInitialized",
  "reset",
];

class ReactOForm extends _ReactOBaseComponent {
  constructor(props) {
    //		console.log("DEBUG :: ReactOForm -> constructor");
    var initState = {
      _initialized: false,
      _is_mounted: false,
      _is_dirty: false,
    };
    super(props, initState);

    this._REGISTERED_INPUTS = {};
    this._FORM_DATA = {};
    this._DATA_SNAPSHOT = {};

    this._DATA_VALIDATORS = {};
    this._ENTRY_PATHS_WITH_VALIDATORS = [];

    if (this.props.onControllerReady) {
      this.props.onControllerReady(this.getContext().ReactOForm);
    }
  }

  init(init_data) {
    //		console.log("DEBUG :: ReactOForm _ init");
    this.setFormData(
      init_data
        ? {
            ...this._FORM_DATA,
            ...(this.props.preInit
              ? this.props.preInit(JSON.parse(JSON.stringify(init_data)))
              : JSON.parse(JSON.stringify(init_data))),
          }
        : JSON.parse(JSON.stringify(this._FORM_DATA)),
      () => {
        this.setState({
          _initialized: true,
        });
      }
    );
  }

  isReady() {
    return this.state._is_mounted && this.state._initialized;
  }

  getFormData() {
    //		console.log("DEBUG :: ReactOForm _ getFormData");
    return JSON.parse(JSON.stringify(this._FORM_DATA));
  }

  composeFormData(data) {
    //		console.log("DEBUG :: ReactOForm _ composeFormData");

    let _TMP_formData = JSON.parse(JSON.stringify(data));
    let _inputsPool = Object.values(this._REGISTERED_INPUTS);
    _inputsPool.forEach((_C_input, _C_idx1) => {
      if (_C_input._defined && _C_input.aliasFor) {
        let _for_data_key =
          typeof _C_input.aliasFor == "object"
            ? _C_input.aliasFor.data_key
            : _C_input.aliasFor;
        let _for_data =
          typeof _C_input.aliasFor == "object" &&
          typeof _C_input.aliasFor.out_modifier == "function"
            ? _C_input.aliasFor.out_modifier(this.getEntry(_C_input.data_key))
            : this.getEntry(_C_input.data_key);
        this.setEntry(_for_data_key, _for_data, _TMP_formData);
        this.setEntry(_C_input.data_key, false, _TMP_formData);
      }
      if (_C_input._defined && _C_input.auxiliary) {
        this.setEntry(_C_input.data_key, false, _TMP_formData);
      }
    });
    return _TMP_formData;
  }

  setFormData(data, cb) {
    //	console.log("DEBUG :: ReactOForm _ setFormData");
    this._FORM_DATA = data;
    if (cb) cb();
  }

  _cleanHiddenEntries(form_data) {
    if (Array.isArray(form_data)) {
      form_data.forEach((_CURR_data, _CURR_idx) => {
        _CURR_data = this._cleanHiddenEntries(_CURR_data);
      });
    } else {
      Object.keys(form_data).forEach((_CURR_key, _CURR_idx) => {
        if (/^_HIDDEN_/.test(_CURR_key)) {
          delete form_data[_CURR_key];
        }
      });
    }
    return form_data;
  }

  takeFirstSnapshot() {
    // if (!this._FIRST_SNAPSHOT_DONE) {
    this.takeSnapshot();
    // 	this._FIRST_SNAPSHOT_DONE = true;
    // }
    //		console.log("DEBUG :: ReactOForm _ takeFirstSnapshot                                                                                                                 FIRST SNAPSHOT");
    // if (!this._FIRST_SNAPSHOT_DONE) {
    // 	let _first_inputs_definition_cycle_done = true;
    // 	let _inputsPool = Object.values(this._REGISTERED_INPUTS);
    // 	if (_inputsPool.length == 0) {
    // 		_first_inputs_definition_cycle_done = false;
    // 	} else {
    // 		_inputsPool.forEach((_C_input, _C_idx1) => {
    // 			console.log("")
    // 			console.log(_C_input.data_key + " (" + _C_input.type + ")");
    // 			console.log("first definition DONW: " + _C_input._firstDefinitionEvaluationDone);
    // 			console.log((_C_input.type != 'error_display') + ' && ' + (!_C_input._firstDefinitionEvaluationDone))
    // 			if (_C_input.type != 'error_display' && !_C_input._firstDefinitionEvaluationDone) {
    // 				_first_inputs_definition_cycle_done = false;
    // 			}
    // 		})
    // 	}
    // 	console.log("takeFirstSnapshot " + _first_inputs_definition_cycle_done)

    // 	if (_first_inputs_definition_cycle_done) {
    // 		console.log("takeFirstSnapshot")
    // 		this.takeSnapshot();
    // 		this._FIRST_SNAPSHOT_DONE = true;
    // 	}
    // }
  }

  takeSnapshot() {
    //		console.log("DEBUG :: ReactOForm _ takeSnapshot                                                                                                                      SNAPSHOT");
    this._DATA_SNAPSHOT = JSON.parse(JSON.stringify(this._FORM_DATA));
    // console.log("take snapshot")
    // console.log("_DATA_SNAPSHOT" + JSON.stringify(this._DATA_SNAPSHOT))
    // console.log("_FORM_DATA" + JSON.stringify(this._FORM_DATA))
  }

  isInitialized() {
    return this.state._initialized === true;
  }

  registerInput(input_params) {
    //		console.log("___REGISTERING " + input_params.type);
    this._REGISTERED_INPUTS[input_params.data_key] = input_params;
  }

  unregisterInput(input_data_key) {
    //		console.log("___UNREGISTERING " + input_data_key);
    delete this._REGISTERED_INPUTS[input_data_key];
  }

  getRegisteredInputs() {
    return this._REGISTERED_INPUTS;
  }

  onGetChildContext() {
    return {};
  }

  handleFormChange(data_key, value, cb) {
    let _entryInput = this._REGISTERED_INPUTS[data_key];
    if (_entryInput && !_entryInput._defined) {
      this.defineEntry(data_key);
    }
    if (
      _entryInput.type == "select" &&
      _entryInput.forceFirstDefault &&
      value == false
    ) {
      this.setEntry(
        data_key,
        (typeof _entryInput.options == "function"
          ? _entryInput.options(this.getFormData())
          : _entryInput.options
        ).filter((value) => {
          return typeof value != "function";
        })[0].value
      );
    } else {
      this.setEntry(data_key, value);
    }
    this.validate(data_key);
    this.forceUpdate();
    if (cb) cb();
  }

  getEntry(entry_path, data) {
    //		console.log("DEBUG :: ReactOForm _ getEntry");
    //		console.log(entry_path);
    //		console.log(this._FORM_DATA);
    var BreakException = {};
    let e_path_array = entry_path.split(".");
    let _TMP = data || this._FORM_DATA;
    let ret = true;
    try {
      e_path_array.forEach((entry, idx) => {
        if (_TMP[entry] === undefined) {
          throw BreakException;
        }
        _TMP = _TMP[entry];
        ret = _TMP;
      });
    } catch (e) {
      if (e !== BreakException) throw e;
      ret = undefined;
    }
    return ret;
  }

  setEntry(entry_path, value, data) {
    //	console.log("DEBUG :: ReactOForm _ setEntry");
    //	console.log("entry_path: " + entry_path);
    //	console.log("     value: " + value);
    let e_path_array = entry_path.split(".");

    let _TMP = data || this._FORM_DATA;
    e_path_array.forEach((entry, idx) => {
      if ((entry == "" && !_TMP) || (entry != "" && !_TMP[entry])) {
        if (entry == "") {
          _TMP =
            e_path_array[idx + 1] && /\d+/.test(e_path_array[idx + 1])
              ? []
              : {};
        } else {
          _TMP[entry] =
            e_path_array[idx + 1] && /\d+/.test(e_path_array[idx + 1])
              ? []
              : {};
        }
      }
      if (idx == e_path_array.length - 1) {
        if (value === false || value === undefined) {
          if (Array.isArray(_TMP)) {
            _TMP.splice(parseInt(entry), 1);
          } else {
            delete _TMP[entry];
          }
        } else {
          if (entry == "") {
            _TMP = value;
          } else {
            _TMP[entry] = value;
          }
        }
      }
      _TMP = entry == "" ? _TMP : _TMP[entry];
    });

    //		console.log("FORM DATA____________");
    //		console.log(this._FORM_DATA);
    //		console.log(this._REGISTERED_INPUTS);
    //		console.log(this._DATA_SNAPSHOT);
    this.notifyOnDataFormChanged();
  }

  isEntryDefined(entry_path) {
    return this.getEntry(entry_path) !== undefined;
  }

  getValidationEntry(entry_path) {
    //	console.log("DEBUG :: ReactOForm _ getValidationEntry");
    //	console.log(entry_path);
    //	console.log(this._FORM_DATA);
    var BreakException = {};
    let e_path_array = entry_path.split(".");
    let _TMP = this._DATA_VALIDATORS;
    let ret = true;
    try {
      e_path_array.forEach((entry, idx) => {
        //	console.log("__________________" + entry + "_____________________>");
        if (_TMP[entry] === undefined) {
          throw BreakException;
        }
        //	console.log("qui");
        _TMP =
          _TMP[entry] && _TMP[entry]._array && idx < e_path_array.length - 1
            ? _TMP[entry]._array
            : _TMP[entry];
        //	console.log(_TMP);
        ret = _TMP;
      });
    } catch (e) {
      if (e !== BreakException) throw e;
      ret = undefined;
    }
    //	console.log("_DATA_VALIDATORS");
    //	console.log(this._DATA_VALIDATORS);
    //	console.log(this._ENTRY_PATHS_WITH_VALIDATORS);
    return ret;
  }

  setValidationEntry(entry_path, value, cb) {
    //		console.log("DEBUG :: ReactOForm _ setValidationEntry");
    if (!entry_path) return;
    let e_path_array = entry_path.split(".");
    let _TMP = this._DATA_VALIDATORS;
    e_path_array.forEach((entry, idx) => {
      if (!_TMP[entry]) {
        _TMP[entry] = { validators: [] };
      }
      if (
        e_path_array[idx + 1] &&
        /^(\d+)$/.test(e_path_array[idx + 1]) &&
        !_TMP[entry]._array
      ) {
        _TMP[entry]._array = [];
      }
      if (idx == e_path_array.length - 1) {
        if (value === false) {
          if (Array.isArray(_TMP)) {
            _TMP.splice(parseInt(entry), 1);
          } else {
            delete _TMP[entry];
          }
          this._ENTRY_PATHS_WITH_VALIDATORS.splice(
            this._ENTRY_PATHS_WITH_VALIDATORS.indexOf(entry_path),
            1
          );
          let _TMP1 = /\.(\d)+$/.exec(entry_path);
          if (_TMP1) {
            this._ENTRY_PATHS_WITH_VALIDATORS.forEach(
              (_CURR_entry, _CURR_idx) => {
                let _TMP2 = /(.*\.)(\d)+$/.exec(entry_path);
                let _base = _TMP2[1];
                let _num = parseInt(_TMP2[2]);
                let re = new RegExp(_base + "(\\d)+$");
                let _TMP = re.exec(_CURR_entry);
                if (_TMP && _TMP[1] && parseInt(_TMP[1]) > _num) {
                  this._ENTRY_PATHS_WITH_VALIDATORS[_CURR_idx] =
                    _base + (parseInt(_TMP[1]) - 1);
                }
              }
            );
          } else {
            let _cleaned = [];
            this._ENTRY_PATHS_WITH_VALIDATORS.forEach(
              (_CURR_entry, _CURR_idx) => {
                let re = new RegExp(entry_path + ".*$");
                if (!re.test(_CURR_entry)) {
                  _cleaned.push(_CURR_entry);
                }
              }
            );
            this._ENTRY_PATHS_WITH_VALIDATORS = _cleaned;
          }
        } else {
          if (_TMP._array) {
            _TMP._array[entry] =
              typeof value == "object" ? { ..._TMP[entry], ...value } : value;
          } else {
            _TMP[entry] =
              typeof value == "object" ? { ..._TMP[entry], ...value } : value;
          }
        }
      }
      _TMP =
        _TMP[entry] && _TMP[entry]._array ? _TMP[entry]._array : _TMP[entry];
    });
    if (cb) cb();
  }

  validate(data_key, cb) {
    //		console.log("DEBUG :: ReactOForm _ validate");
    //		console.log("data_key: " + data_key);

    let _TMP_isDirty = false;

    let _inputsPool = data_key
      ? this._REGISTERED_INPUTS[data_key]
        ? [this._REGISTERED_INPUTS[data_key]]
        : []
      : Object.values(this._REGISTERED_INPUTS);
    _inputsPool.forEach((_C_input, _C_idx1) => {
      if (_C_input._defined) {
        (_C_input.validators || []).every((_C_validator, _C_idx2) => {
          if (!_C_validator.func) {
            return true;
          }
          let _C_result = _C_validator.func(
            this.getEntry(_C_input.data_key),
            this.getFormData()
          );
          if (_C_validator.type == "bypass") {
            return _C_result === true ? false : true;
          }
          if (_C_result === true) {
            _C_input._validation.result = true;
            _C_input._validation.message = _C_validator.valid_text || "";
          } else {
            _C_input._validation.result = false;
            _C_input._validation.message = _C_validator.invalid_text || "";
            _TMP_isDirty = true;
            return false;
          }
          return true;
        });
      }
    });

    //		console.log("IS DIRTY: " + _TMP_isDirty);
    //		console.log(this._REGISTERED_INPUTS);
    this.setState({ _is_dirty: _TMP_isDirty }, () => {
      if (cb) {
        cb(_TMP_isDirty);
      }
    });
  }

  validateRemote(data_key, valid_result, cb) {
    //	console.log("DEBUG :: ReactOForm _ validateRemote");
    //	console.log("data_key: " + data_key);
    //	console.log("valid_result: " + valid_result);

    let _TMP_isDirty = false;

    let _inputsPool = data_key
      ? this._REGISTERED_INPUTS[data_key]
        ? [this._REGISTERED_INPUTS[data_key]]
        : []
      : Object.values(this._REGISTERED_INPUTS);
    _inputsPool.forEach((_C_input, _C_idx1) => {
      if (_C_input._defined) {
        (_C_input.remote_validators || []).every((_C_validator, _C_idx2) => {
          if (!_C_validator.func) {
            return true;
          }
          let _C_result = _C_validator.func(valid_result, this.getFormData());
          if (_C_validator.type == "bypass") {
            return _C_result === true ? false : true;
          }
          if (_C_result === true) {
            _C_input._validation.result = true;
            _C_input._validation.message = _C_validator.valid_text || "";
          } else {
            _C_input._validation.result = false;
            _C_input._validation.message = _C_validator.invalid_text || "";
            _TMP_isDirty = true;
            return false;
          }
          return true;
        });
      }
    });

    //		console.log("IS DIRTY: " + _TMP_isDirty);
    //		console.log(this._REGISTERED_INPUTS);
    this.setState({ _is_dirty: _TMP_isDirty }, () => {
      if (cb) {
        cb(_TMP_isDirty);
      }
    });
  }

  resetValidations(cb) {
    let _inputsPool = Object.values(this._REGISTERED_INPUTS);
    _inputsPool.forEach((_C_input, _C_idx1) => {
      _C_input._validation = { result: null, message: "" };
    });

    this.setState({ _is_dirty: false }, cb || null);
  }

  reset() {
    this.resetValidations();
    //	this._REGISTERED_INPUTS = {}
    this._FORM_DATA = {};
    this._DATA_SNAPSHOT = {};
    this.setState(
      {
        _initialized: false,
        _is_dirty: false,
      },
      () => {
        this.init({});
        this.forceUpdate();
      }
    );
  }

  isValid(data_key) {
    //		console.log("DEBUG :: ReactOForm _ isValid");
    //		console.log("data_key: " + data_key);

    let _entryInput = this._REGISTERED_INPUTS[data_key];
    return _entryInput && _entryInput._defined
      ? _entryInput._validation.result === true
      : null;
  }

  isInvalid(data_key) {
    //		console.log("DEBUG :: ReactOForm _ isInvalid");
    //		console.log("data_key: " + data_key);

    let _entryInput = this._REGISTERED_INPUTS[data_key];
    return _entryInput && _entryInput._defined
      ? _entryInput._validation.result === false
      : null;
  }

  getValidationResult(data_key) {
    //		console.log("DEBUG :: ReactOForm _ getValidationResult");
    //		console.log("data_key: " + data_key);

    let _entryInput = this._REGISTERED_INPUTS[data_key];
    return _entryInput && _entryInput._defined
      ? _entryInput._validation
      : { result: null, message: "" };
  }

  isDirty() {
    return this.state._is_dirty;
  }

  isChanged() {
    return !deepEqual(this._FORM_DATA, this._DATA_SNAPSHOT);
  }

  restoreData(cb) {
    //		console.log("DEBUG :: ReactOForm _ restoreData");
    this._FORM_DATA = JSON.parse(JSON.stringify(this._DATA_SNAPSHOT));
    this.resetValidations(cb ? cb : null);
  }

  resetDefault(entry_path, default_value) {
    this.setEntry(entry_path, default_value);
  }

  evaluateDefinition(data_key) {
    // console.log("DEBUG :: ReactOForm _ evaluateDefinition");
    // console.log("DATA_KEY: " + data_key);
    let _return = false;
    let _entryInput = this._REGISTERED_INPUTS[data_key];
    if (_entryInput) {
      if (_entryInput.defineIf !== undefined) {
        if (_entryInput.defineIf(this.getFormData())) {
          this.defineEntry(data_key);
          _return = true;
        } else {
          this.destroyEntry(data_key);
          _return = false;
        }
      } else if (_entryInput.aliasFor !== undefined) {
        if (
          this.getEntry(
            typeof _entryInput.aliasFor == "object"
              ? _entryInput.aliasFor.data_key
              : _entryInput.aliasFor
          ) ==
          "_ALIAS_" + _entryInput.data_key
        ) {
          this.defineEntry(data_key);
          _return = true;
        } else {
          this.destroyEntry(data_key);
          _return = false;
        }
      } else {
        this.defineEntry(data_key);
        _return = true;
      }

      if (!_entryInput._firstDefinitionEvaluationDone) {
        //				console.log("evaluateDefinition");
        //				console.log(_entryInput.data_key + " (" + _entryInput.type + ")");
        _entryInput._firstDefinitionEvaluationDone = true;
        this.takeFirstSnapshot();
      }
    } else {
      /**
				Se il ReactOFormInput non risulta ancora registrato al ReactOForm,
				ritorno il messaggio in modo che il ReactOFormInput in questione
				possa ri-renderizzare dopo essersi resistrato.
				(Vedi ReactOFormInput -> onRender)	
			*/
      return "_NOT_REGISTERED_";
    }
    return _return;
  }

  getAliasInput(data_key) {
    let _return = undefined;
    Object.values(this._REGISTERED_INPUTS).every((_C_regInput) => {
      if (
        _C_regInput.aliasFor &&
        ((typeof _C_regInput.aliasFor == "object" &&
          _C_regInput.aliasFor.data_key == data_key) ||
          _C_regInput.aliasFor == data_key)
      ) {
        _return = _C_regInput;
        return false;
      }
      return true;
    });
    return _return;
  }

  defineEntry(data_key) {
    // console.log("DEBUG :: ReactOForm _ defineEntry");
    // console.log("data_key: " + data_key);

    let _entryInput = this._REGISTERED_INPUTS[data_key];
    if (!_entryInput || _entryInput._defined) {
      return;
    }
    if (
      !/^(submit|error_display)$/.test(_entryInput.type) &&
      _entryInput.data_key !== undefined
    ) {
      _entryInput._validation = { result: null, message: "" };
      _entryInput._defined = true;
      if (this.getEntry(data_key) === undefined) {
        if (_entryInput.type == "select" && _entryInput.forceFirstDefault) {
          this.setEntry(
            data_key,
            (typeof _entryInput.options == "function"
              ? _entryInput.options(this.getFormData())
              : _entryInput.options
            ).filter((value) => {
              return typeof value != "function";
            })[0].value
          );
        } else if (_entryInput.default !== undefined) {
          this.setEntry(
            data_key,
            typeof _entryInput.default == "function"
              ? _entryInput.default(this.getContext().ReactOForm)
              : _entryInput.default
          );
        }
      } else if (_entryInput.aliases) {
        _entryInput.aliases.every((_C_alias) => {
          let _C_entryValue = this.getEntry(data_key);
          if (
            _C_alias.applyIf &&
            _C_alias.applyIf(_C_entryValue, this.getFormData())
          ) {
            let _aliasInput = this._REGISTERED_INPUTS[_C_alias.to];
            if (_aliasInput) {
              let _TMP_toSet =
                typeof _aliasInput.aliasFor == "object" &&
                _aliasInput.aliasFor.in_modifier
                  ? _aliasInput.aliasFor.in_modifier(_C_entryValue)
                  : _C_entryValue;
              this.setEntry(_aliasInput.data_key, _TMP_toSet);
              this.setEntry(data_key, "_ALIAS_" + _aliasInput.data_key);
              return false;
            }
          }
          return true;
        });
      }
      if (_entryInput.onInputDidDefine) {
        _entryInput.onInputDidDefine(this.getContext().ReactOForm);
      }
    }

    //		if (/^text|password|email|hidden|select|checkbox|switch|array$/.test(new_entry.type)) {
    //			let _CURR_valid_data = this.getValidationEntry(new_entry.name);
    //			if (_CURR_valid_data === undefined || (_CURR_valid_data.validators === undefined && new_entry.validators !== undefined)) {
    //				if (new_entry.validators && new_entry.name) {
    //					this._ENTRY_PATHS_WITH_VALIDATORS.push(new_entry.name);
    //
    //					this.setValidationEntry(new_entry.name, {
    //						validators: new_entry.validators,
    //						status: {
    //							result: null,
    //							message: ""
    //						}
    //					});
    //				}
    //			}
    //		}
    //		if (/^text|password|email|hidden|select|checkbox|switch$/.test(new_entry.type)) {
    //		//	if (!this.isEntryDefined(new_entry.name)) {
    //			let _CURR_entry_value = this.getEntry(new_entry.name);
    //				this.setEntry(new_entry.name, _CURR_entry_value === undefined ? new_entry.default : _CURR_entry_value, () => {
    //				//	this.setRegisteredInputReady(new_entry.name);
    //				});
    //		//	}
    //		} else if (new_entry.type == 'array') {
    //		//	if (!this.isEntryDefined(new_entry.name)) {
    //			let _CURR_entry_value = this.getEntry(new_entry.name);
    //				this.setEntry(new_entry.name, _CURR_entry_value === undefined ? [""] : _CURR_entry_value, () => {
    //				//	this.setRegisteredInputReady(new_entry.name);
    //				});
    //		//	}
    //		}
  }

  destroyEntry(data_key) {
    //		console.log("DEBUG :: ReactOForm _ destroyEntry");
    //		console.log("data_key: " + data_key);
    let _entryInput = this._REGISTERED_INPUTS[data_key];
    if (!_entryInput || !_entryInput._defined) {
      return;
    }

    if (_entryInput.onInputWillUndefine) {
      _entryInput.onInputWillUndefine(this.getContext().ReactOForm);
    }
    _entryInput._validation = { result: null, message: "" };
    this.setEntry(data_key, false);
    _entryInput._defined = false;
    if (_entryInput.type == "array") {
      Object.keys(this._REGISTERED_INPUTS).forEach((_C_regInputKey, _C_idx) => {
        let re = new RegExp(_entryInput.data_key + "\\.\\d+");
        if (re.test(this._REGISTERED_INPUTS[_C_regInputKey].data_key)) {
          delete this._REGISTERED_INPUTS[_C_regInputKey];
        }
      });
    }
    if (_entryInput.type == "password") {
      this.setEntry(data_key + "_l", false);
    }
    this.validate(data_key);

    //		//
    //		// Non "distruggo" l'entry prima che il form sia inizializzato per evitare di eliminare i dati prematuramente a causa della prop "defineIf"
    //		//
    //		if (!this.isInitialized()) {return;}
    //		if (this.isEntryDefined(entry_path)) {
    //			this.setEntry(entry_path, false);
    //			this.setValidationEntry(entry_path, false);
    //		} else {
    ////			console.log("===================================> NOT DEFINED ENTRY.");
    //		}
  }

  notifyOnDataFormChanged() {
    if (this.props.onFormDataChange && this.isReady()) {
      this.props.onFormDataChange(this._FORM_DATA);
    }
  }

  getErrorMessage() {
    //		console.log("DEBUG :: ReactOForm _ getErrorMessage");
    return this.state.errorMessage;
  }

  submitOnEnterKey() {
    return (
      this.props.submitOnEnterKey !== undefined &&
      this.props.submitOnEnterKey !== false
    );
  }

  submit(cb, opt) {
    //		console.log("DEBUG :: ReactOForm _ submit");
    if (this.props.onFormWillSubmit) {
      this.props.onFormWillSubmit();
    }
    this.validate(null, (is_dirty) => {
      if (!is_dirty) {
        let _uploadInputs = Object.values(this._REGISTERED_INPUTS).filter(
          (_C_input) => {
            return _C_input.type == "upload";
          }
        );
        Promise.all([
          ..._uploadInputs
            .map((_C_input) => {
              return _C_input.onUpload !== undefined
                ? new Promise((resolve, reject) => {
                    _C_input.onUpload(
                      this.getEntry(_C_input.data_key),
                      (_submit_status, _submit_data) => {
                        if (_submit_status == "OK") {
                          this.setEntry(_C_input.data_key, []);
                        }
                        resolve({
                          status: "ok",
                          data: _submit_data,
                        });
                      }
                    );
                  })
                : null;
            })
            .filter((value) => {
              return value != null;
            }),
          ...(this.props.onSubmit
            ? [
                new Promise((resolve, reject) => {
                  this.props.onSubmit(
                    this.composeFormData(
                      this.props.preSubmit
                        ? this.props.preSubmit(this.getFormData())
                        : this.getFormData()
                    ),
                    (_submit_status, _submit_data, submit_cb) => {
                      if (_submit_status == "OK") {
                        resolve({
                          status: "ok",
                          data: _submit_data,
                        });
                      } else {
                        this.setState(
                          {
                            errorMessage: _submit_data,
                          },
                          () => {
                            resolve({
                              status: "ko",
                              data: _submit_data,
                            });
                          }
                        );
                      }
                      if (submit_cb) submit_cb();
                    },
                    opt
                  );
                }),
              ]
            : []),
        ]).then((values) => {
          //	console.log("!! SUBMIT DONE !!");
          let _submitSuccessful = true;
          values.forEach((_C_value, _C_idx) => {
            (_C_value.data &&
            _C_value.data.data &&
            _C_value.data.data.validation
              ? _C_value.data.data.validation
              : []
            ).forEach((_C_validation, _C_idx) => {
              this.validateRemote(_C_validation.data_key, _C_validation.error);
            });
            if (_C_value.status != "ok") {
              _submitSuccessful = false;
            }
          });
          if (_submitSuccessful) {
            this.takeSnapshot();
            if (cb) cb({ status: true, message: "" });
            if (this.props.onFormDidSubmit) {
              this.props.onFormDidSubmit(this.state._is_dirty);
            }
          }
        });
      } else {
        if (cb) cb({ status: false, message: "IS_DIRTY" });
        if (this.props.onFormDidSubmit) {
          this.props.onFormDidSubmit();
        }
      }
    });
  }

  //
  //	Lifecycle methods
  //

  onComponentDidUpdate() {
    //	console.log("DEBUG :: ReactOForm _ onComponentDidUpdate");
  }

  onComponentDidMount() {
    //		console.log("DEBUG :: ReactOForm _ onComponentDidMount");
    if (this.props.ignoreClick) {
      if (this.context._Prompter) {
        this.context._Prompter.definePrompter((_continue) => {
          if (this.isChanged()) {
            this._PROMPT_POST_ACTION = _continue;

            return false;
          } else {
            this._PROMPT_POST_ACTION = null;
            return _continue;
          }
        });
      }
    }
    if (this.props.unsavedWarning) {
      if (this.context._Prompter) {
        this.context._Prompter.definePrompter((_continue) => {
          if (this.isChanged()) {
            this._PROMPT_POST_ACTION = _continue;
            this._unsavedWarn_modal.open();
            return false;
          } else {
            this._PROMPT_POST_ACTION = null;
            return _continue;
          }
        });
      }
      this.getAppContext().defineRedirectionPrompter((_continue) => {
        if (this.isChanged()) {
          this._PROMPT_POST_ACTION = _continue;
          this._unsavedWarn_modal.open();
          return false;
        } else {
          this._PROMPT_POST_ACTION = null;
          return _continue;
        }
      });
    }
    this.setState({
      _is_mounted: true,
    });
  }

  onComponentWillUnmount() {
    if (this.context._Prompter) {
      this.context._Prompter.deleteDefinedPrompter();
    }
  }

  onRender() {
    return (
      <Form
        onSubmit={(e) => {
          //					console.log("SUBMIT...")
          e.preventDefault();
          return false;
          //	this.submit();
        }}
      >
        {this.props.children}

        {this.props.unsavedWarning
          ? [
              <ReactOModal
                key="1"
                modalId="unsavedWarning"
                size="md"
                onControllerReady={(modal_context) => {
                  this._unsavedWarn_modal = modal_context;
                }}
                header="Unsaved changes"
                body="Do you want to save changes?"
                actions={[
                  {
                    text: "Cancel",
                    color: "light",
                    action: "close",
                  },
                  {
                    text: "Discard",
                    color: "light",
                    icon: "delete",
                    action: () => {
                      this._unsavedWarn_modal.close();
                      this.restoreData(() => {
                        if (this._PROMPT_POST_ACTION)
                          this._PROMPT_POST_ACTION();
                      });
                    },
                  },
                  {
                    text: "Save",
                    color: "primary",
                    icon: "save",
                    action: () => {
                      this._unsavedWarn_modal.close();
                      this.submit((submit_result) => {
                        if (submit_result.status) {
                          if (this._PROMPT_POST_ACTION)
                            this._PROMPT_POST_ACTION();
                        }
                      });
                    },
                  },
                ]}
              />,
            ]
          : null}

        {(() => {
          //					if (this.state._initialized == 'initializing') {
          ////						console.log("======================================================================================================> FORM initialized                                  FORM initialized");
          //						this.setState({
          //							_initialized: true
          //						}, () => {
          //							this.takeSnapshot(() => {this.setFormData(JSON.parse(JSON.stringify(this._DATA_SNAPSHOT)))});
          //							if (this.props.onFormInitialized) {
          //								this.props.onFormInitialized(this.getContext().ReactOForm);
          //							}
          //						});
          //					}
        })()}
      </Form>
    );
  }
}

export default contextProvider(
  withDefinedContext(ReactOForm, "ReactOForm", context_exposed_methods),
  {
    retrieve: ["ReactOTabsPanel", "_Prompter"],
  }
);
